module.exports = __webpack_public_path__ + "static/media/sleep-doctor.2c091d77.svg";